import { useState } from "react";
import {
  Form,
  Input,
  Row,
  Col
} from "antd";

import  useOperacaoDropdownList from "../../../hooks/useOperacaoDropdownList";
import usePlanoOperacionalSubgrupoDropdownList from "../../../hooks/usePlanoOperacionalSubgrupoDropdownList";
import { SelectAntd } from "../styles";

const { Item } = Form;

type Props = {
  filtersData: any,
  form: any
};

export function FormModal({ filtersData, form }: Props) {
    const classeOperacao = form.getFieldValue('classeOperacao');
    const grupoPacote = form.getFieldValue('grupoPacote');
    const { data: operacaoList } = useOperacaoDropdownList({ OperacaoClasseIdExterno: classeOperacao });
    const { data: grupoPacoteList } = usePlanoOperacionalSubgrupoDropdownList(grupoPacote);
    const [searchSafra, setSearchSafra] = useState<Record<number, string>>({});
    const [searchCenario, setSearchCenario] = useState<Record<number, string>>({});
    const [searchCultura, setSearchCultura] = useState<Record<number, string>>({});
    const [searchFazenda, setSearchFazenda] = useState<Record<number, string>>({});
    const [searchClasseOperacao, setSearchClasseOperacao] = useState<Record<number, string>>({});
    const [searchOperacao, setSearchOperacao] = useState<Record<number, string>>({});
    const [searchGrupoPacote, setSearchGrupoPacote] = useState<Record<number, string>>({});
    const [searchSubGrupoPacote, setSearchSubGrupoPacote] = useState<Record<number, string>>({});
    
    return (
        <>
        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Item 
              label="Safra"
              name="safra"
              >
                <SelectAntd 
                  showSearch
                  optionFilterProp="label"
                  allowClear
                  options={filtersData?.safraList?.map((item: any) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                  onSearch={(searchText) => {
                    setSearchSafra(searchText);
                  }}
                  onInputKeyDown={(e) => {
                    if (e.key === "Tab") {
                      const searchText = searchSafra;

                      if (!searchText) return;
                      
                      const filteredOptions =
                      filtersData?.safraList
                      ?.map((item: any) => ({
                        label: item.text,
                        value: item.value,
                      }))
                      ?.filter((option: any) =>
                        option.label?.toLowerCase().includes(searchText)
                    ) || [];
                    
                      if (filteredOptions.length === 1) {
                        const onlyMath = filteredOptions[0];
                        form.setFieldsValue({
                          safra: onlyMath.value
                        });
                      }
                    }
                  }}
                  />
            </Item>
          </Col>

          <Col span={8}>
            <Item 
              label="Cenário"
              name="cenario"
              rules={[{ required: true, message: "Campo Cenário é obrigatório" }]}
              >
              <SelectAntd 
                  showSearch
                  optionFilterProp="label"
                  
                  options={filtersData?.cenarioList?.map((item: any) => ({
                    label: item.text,
                    value: item.value,
                  }))}
                  onSearch={(searchText) => {
                    setSearchCenario(searchText);
                  }}
                  onInputKeyDown={(e) => {
                    if (e.key === "Tab") {
                      const searchText = searchCenario;

                      if (!searchText) return;
                      
                      const filteredOptions =
                      filtersData?.cenarioList
                      ?.map((item: any) => ({
                        label: item.text,
                        value: item.value,
                      }))
                      ?.filter((option: any) =>
                        option.label?.toLowerCase().includes(searchText)
                    ) || [];
                    
                    if (filteredOptions.length === 1) {
                      const onlyMath = filteredOptions[0];
                      form.setFieldsValue({
                        cenario: onlyMath.value
                      });
                    }
                    }
                  }}
                  />

            </Item>
          </Col>
          <Col span={8}>
            <Item 
              label="Cultura"
              name="cultura"
              rules={[{ required: true, message: "Campo Cultura é obrigatório" }]}
              >
                <SelectAntd 
                    showSearch
                    optionFilterProp="label"
                    
                    options={filtersData?.ocupacaoList?.map((item: any) => ({
                      label: item.text,
                      value: item.value,
                    }))}
                    onSearch={(searchText) => {
                      setSearchCultura(searchText);
                    }}
                    onInputKeyDown={(e) => {
                      if (e.key === "Tab") {
                        const searchText = searchCultura;

                        if (!searchText) return;
                        
                        const filteredOptions =
                          filtersData?.ocupacaoList
                          ?.map((item: any) => ({
                            label: item.text,
                            value: item.value,
                          }))
                          ?.filter((option: any) =>
                            option.label?.toLowerCase().includes(searchText)
                        ) || [];

                        if (filteredOptions.length === 1) {
                          const onlyMath = filteredOptions[0];
                          form.setFieldsValue({
                            cultura: onlyMath.value
                          });
                        }
                      }
                    }}
                  />

            </Item>
          </Col>
        </Row>

        <Row gutter={[16, 16]}>
          <Col span={8}>
            <Item
              label="Fazenda"
              name="fazenda"
              rules={[{ required: true, message: "Campo Fazenda é obrigatório" }]}
              >
                <SelectAntd
                  showSearch
                  optionFilterProp="label"
                  allowClear
                  options={filtersData?.unidadeList?.map((item: any) => ({
                      label: item.text,
                      value: item.value,
                    }))}
                  onSearch={(searchText) => {
                    setSearchFazenda(searchText);
                  }}
                  onInputKeyDown={(e) => {
                    if (e.key === "Tab") {
                      const searchText = searchFazenda;

                      if (!searchText) return;

                      const filteredOptions =
                        filtersData?.unidadeList
                          ?.map((item: any) => ({
                            label: item.text,
                            value: item.value,
                          }))
                          ?.filter((option: any) =>
                            option.label?.toLowerCase().includes(searchText)
                          ) || [];

                      if (filteredOptions.length === 1) {
                        const onlyMath = filteredOptions[0];
                        form.setFieldsValue({
                          fazenda: onlyMath.value
                        });
                    }
                    }
                  }}
              />
            </Item>
          </Col>

          <Col span={8}>
            <Item 
              label="Classe de Operação"
              name="classeOperacao"
              >
              <SelectAntd
                  onChange={(dataValue: any) => {
                    form.setFieldsValue({ classeOperacao: dataValue });
                  }}
                  showSearch
                  optionFilterProp="label"
                  allowClear
                  options={filtersData?.classeOperacaoList?.map((item: any) => ({
                      label: item.text,
                      value: item.value,
                  }))}
                  onSearch={(searchText) => {
                    setSearchClasseOperacao(searchText);
                  }}
                  onInputKeyDown={(e) => {
                    if (e.key === "Tab") {
                      const searchText = searchClasseOperacao;

                      if (!searchText) return;
                      
                      const filteredOptions =
                        filtersData?.classeOperacaoList
                        ?.map((item: any) => ({
                          label: item.text,
                          value: item.value,
                        }))
                        ?.filter((option: any) =>
                          option.label?.toLowerCase().includes(searchText)
                      ) || [];
                    
                      if (filteredOptions.length === 1) {
                        const onlyMath = filteredOptions[0];
                        form.setFieldsValue({
                          classeOperacao: onlyMath.value
                        });
                      }
                  
                    }
                  }}
              />
            </Item>
          </Col>

          <Col span={8}>
            <Item
              label="Operação"
              name="operacao"
              >
              <SelectAntd 
                  showSearch
                  optionFilterProp="label"
                  allowClear
                  options={operacaoList?.map((item: any) => ({
                      label: item.text,
                      value: item.value,
                    }))}
                  onSearch={(searchText) => {
                    setSearchOperacao(searchText);
                  }}
                  onInputKeyDown={(e) => {
                    if (e.key === "Tab") {
                      const searchText = searchOperacao;

                      if (!searchText) return;
                      
                      const filteredOptions =
                        operacaoList
                        ?.map((item: any) => ({
                          label: item.text,
                          value: item.value,
                        }))
                        ?.filter((option: any) =>
                          option.label?.toLowerCase().includes(searchText)
                      ) || [];
                    
                      if (filteredOptions.length === 1) {
                        const onlyMath = filteredOptions[0];
                        form.setFieldsValue({
                          operacao: onlyMath.value
                        });
                      }
                    }
                  }}
                  />
            </Item>
          </Col>
        </Row>

         <Row gutter={[16, 16]}>
          <Col span={8}>
            <Item
              label="Código do Pacote de Recursos"
              name="codigoPacote"
              >
              <Input
                size="large"
                placeholder="Digite o ID completo do pacote"
                style={{ borderRadius: 8 }}
                type="number"
              />
            </Item>
          </Col>

          <Col span={8}>
            <Item 
              label="Grupo de Pacote"
              name="grupoPacote"
              >
              <SelectAntd
                onChange={(dataValue: any) => {
                  form.setFieldsValue({ grupoPacote: dataValue });
                }}
                showSearch
                optionFilterProp="label"
                allowClear
                options={filtersData?.grupoPlanoOperacionalList?.map((item: any) => ({
                  label: item.text,
                  value: item.value,
                }))}
                onSearch={(searchText) => {
                  setSearchGrupoPacote(searchText);
                }}
                onInputKeyDown={(e) => {
                  if (e.key === "Tab") {
                    const searchText = searchGrupoPacote;

                    if (!searchText) return;
                    
                    const filteredOptions =
                      filtersData?.grupoPlanoOperacionalList
                      ?.map((item: any) => ({
                        label: item.text,
                        value: item.value,
                      }))
                      ?.filter((option: any) =>
                        option.label?.toLowerCase().includes(searchText)
                    ) || [];
                  
                    if (filteredOptions.length === 1) {
                      const onlyMath = filteredOptions[0];
                      form.setFieldsValue({
                        grupoPacote: onlyMath.value
                      });
                    }
                  }
                }}
              />
            </Item>
          </Col>

          <Col span={8}>
            <Item
              label="Subgrupo de Pacote"
              name="subgrupoPacote"
              >
              <SelectAntd
                  showSearch
                  optionFilterProp="label"
                  allowClear
                  options={grupoPacoteList?.map((item: any) => ({
                      label: item.text,
                      value: item.value,
                  }))}
                  onSearch={(searchText) => {
                    setSearchSubGrupoPacote(searchText);
                  }}
                onInputKeyDown={(e) => {
                  if (e.key === "Tab") {
                    const searchText = searchSubGrupoPacote;

                    if (!searchText) return;
                    
                    const filteredOptions =
                      grupoPacoteList
                      ?.map((item: any) => ({
                        label: item.descricao,
                        value: item.idExternoSubgrupoPlanoOperacional,
                      }))
                      ?.filter((option: any) =>
                        option.label?.toLowerCase().includes(searchText)
                    ) || [];
                  
                     if (filteredOptions.length === 1) {
                      const onlyMath = filteredOptions[0];
                      form.setFieldsValue({
                        subgrupoPacote: onlyMath.value
                      });
                    }
                  }
                }}
                  />
                 
            </Item>
          </Col>
        </Row>
      </>
    )
};  